import { render, staticRenderFns } from "./StarterHeader.vue?vue&type=template&id=11b35275&scoped=true"
import script from "./StarterHeader.vue?vue&type=script&lang=js"
export * from "./StarterHeader.vue?vue&type=script&lang=js"
import style0 from "./StarterHeader.vue?vue&type=style&index=0&id=11b35275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b35275",
  null
  
)

export default component.exports